var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    enableBackground: "new 0 0 192 192",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    fill: "#FFFFFF",
    width: 192,
    height: 191.837
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#FFFFFF",
    d: "M24.722,41.139c0-21.435,15.188-30.204,33.751-19.486l94.883,54.78         c18.563,10.717,18.563,28.254,0,38.971l-94.883,54.78c-18.563,10.717-33.751,1.948-33.751-19.486V41.139z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1a07cf74.svg";
export { ForwardRef as ReactComponent };